import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import SiteMeta from "./components/SiteMeta";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/dashboard/Dashboard";
import AdminPanel from "./pages/AdminPanel";
import Storefront from "./pages/Storefront";
import ProductPage from "./pages/ProductPage";
import VoucherPage from "./pages/VoucherPage";
import VoucherConfirm from "./pages/VoucherConfirm";
import CheckBalance from "./pages/CheckBalance";
import ReactionPage from "./pages/ReactionPage";
import StaffApp from "./pages/StaffApp";
import CorporatePage from "./pages/CorporatePage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SiteMeta />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/store/:slug" element={<Storefront />} />
            <Route path="/store/:slug/vouchers/:productSlug" element={<ProductPage />} />
            <Route path="/store/:slug/corporate" element={<CorporatePage />} />
            <Route path="/staff/:slug" element={<StaffApp />} />
            <Route path="/voucher/confirm" element={<VoucherConfirm />} />
            <Route path="/voucher/:code" element={<VoucherPage />} />
            <Route path="/check-balance" element={<CheckBalance />} />
            <Route path="/reaction/:token" element={<ReactionPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
